import { FilterCategoryEnum, FilterTypeEnum } from '@/bundles/GroupFilters/enums/FilterTypeEnum';
import { Nullable } from '@/utils/types';
import { IFilterConfigItem } from '@/bundles/GroupFilters/interfaces/IFilterConfigItem';

export const getParkingFiltersConfigByType = (type: string): IFilterConfigItem[] => [
  {
    title: '# of Total Spaces',
    name: `${type}_parking_count`, // NEW
    type: FilterTypeEnum.number_range,
    category: FilterCategoryEnum.parking,
  },
  {
    title: '# of Covered Spaces',
    name: `${type}_parking_covered_count`, // NEW
    type: FilterTypeEnum.number_range,
    category: FilterCategoryEnum.parking,
  },
  {
    title: '# of Uncovered Spaces',
    name: `${type}_parking_uncovered_count`, // NEW
    type: FilterTypeEnum.number_range,
    category: FilterCategoryEnum.parking,
  },
  {
    title: 'Parking Ratio',
    name: `${type}_parking_ratio`, // NEW
    type: FilterTypeEnum.number_range,
    category: FilterCategoryEnum.parking,
    additional: {
      suffix: '/ 1,000 SF',
    },
    formatter: (v: Nullable<number>) => v?.toString() || '', // don't format
  },
];
